import { IComponentOptions, IController, INgModelController } from 'angular';
import './gmc-password-input.component.scss';

class PasswordInputController implements IController {
  static $inject = [];
  ngModel: INgModelController;
  inputType = 'password';
  value: string;
  placeholder = 'Enter your password';
  labelId: string;
  private icons = {
    text: 'visibility_on',
    password: 'visibility_off'
  };

  constructor() {
  }

  $postLink() {
    this.ngModel.$render = () => {
      this.value = this.ngModel.$viewValue;
    };
  }

  onInputChange() {
    this.ngModel.$setViewValue(this.value);
  }

  toggleInputType() {
    this.inputType = this.inputType === 'password' ? 'text' : 'password';
  }

  get icon(): string {
    return this.icons[ this.inputType ];
  }
}

export const PasswordInputComponent: IComponentOptions = {
  controller: PasswordInputController,
  require: {
    ngModel: 'ngModel'
  },
  template: require('./gmc-password-input.component.html'),
  bindings: {
    placeholder: '@?',
    labelId: '@?'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-password-input/gmc-password-input.component.ts